(() => {
  'use strict';
  const root = document.querySelector('#a2-plate-dialog');
  if (!root) return;
  const form = root.querySelector('form');
  const button = root.querySelector('[data-read-plate]');
  const status = root.querySelector('[data-reader-status]');
  const endpoint = root.dataset.readerEndpoint;
  const review = root.querySelector('[data-plate-review]');
  const reviewHeading = root.querySelector('[data-review-heading]');
  const showReview = () => {
    if (review) review.hidden = false;
    reviewHeading?.focus();
  };
  root.querySelector('[data-plate-manual]')?.addEventListener('click', showReview);
  let revision = 0;
  let controller;
  let busy = false;
  const validEndpoint = (() => {
    try { return new URL(endpoint).protocol === 'https:'; } catch { return false; }
  })();
  button.disabled = !validEndpoint;
  if (!validEndpoint) {
    button.hidden = true;
    if (review) review.hidden = false;
  }
  form.addEventListener('change', () => {
    revision++;
    controller?.abort();
    if (busy) status.textContent = 'Datos modificados. Se ha cancelado la lectura anterior.';
    root.querySelector('[data-plate-results]').replaceChildren();
    for (const field of form.elements) field.removeAttribute('aria-invalid');
  });
  root.addEventListener('close', () => { revision++; controller?.abort(); });
  async function encode(file) {
    if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 15 * 1024 * 1024) {
      throw Error('Selecciona una foto JPG, PNG o WebP de menos de 15 MB.');
    }
    const bitmap = await createImageBitmap(file);
    try {
      const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', .88);
    } finally { bitmap.close(); }
  }
  button.addEventListener('click', async () => {
    if (!validEndpoint || busy) return;
    const photos = root.querySelectorAll('[data-photo-input]');
    if (!photos[0].files[0]) { status.textContent = 'Añade primero una foto de la placa.'; return; }
    busy = true;
    button.disabled = true;
    const current = ++revision;
    controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 35000);
    status.textContent = 'Leyendo la placa…';
    try {
      const payload = {plate: await encode(photos[0].files[0])};
      if (photos[1].files[0]) payload.mount = await encode(photos[1].files[0]);
      if (current !== revision) return;
      const response = await fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit', body:JSON.stringify(payload), signal:controller.signal});
      if (!response.ok) throw Error(response.status === 429 ? 'Límite de lecturas alcanzado. Puedes buscar manualmente o consultar al taller.' : 'El lector no está disponible. Introduce los datos o consulta al taller.');
      const {reading} = await response.json();
      if (current !== revision) return;
      if (!reading || typeof reading !== 'object') throw Error('No se pudo obtener una lectura válida.');
      const allowed = {phase:['Monofásico','Trifásico'], mount:['B3','B5','B14','B35','B34'], brake:['No','Sí'], application:['Estándar','ATEX']};
      for (const [key, values] of Object.entries(allowed)) form.elements[key].value = values.includes(reading[key]) ? reading[key] : (key === 'phase' ? '' : 'unknown');
      for (const key of ['kw', 'rpm']) form.elements[key].value = typeof reading[key] === 'number' && Number.isFinite(reading[key]) && reading[key] > 0 ? reading[key] : '';
      form.elements.voltage.value = ['230','230/400','400/690'].includes(reading.voltage) ? reading.voltage : '';
      form.elements.hz.value = reading.frequency === '50 Hz' ? '50' : reading.frequency === '60 Hz' ? '60' : 'unknown';
      root.querySelector('[data-plate-results]').replaceChildren();
      const labels = {phase:'tipo de corriente',kw:'potencia',rpm:'velocidad',voltage:'voltaje',hz:'frecuencia',mount:'cómo se sujeta'};
      const missing = Object.keys(labels).filter(key => !form.elements[key].value || form.elements[key].value === 'unknown');
      for (const key of missing) form.elements[key].setAttribute('aria-invalid', 'true');
      status.textContent = missing.length ? 'Foto leída. Nos falta: '+missing.map(key=>labels[key]).join(', ')+'. Complétalo abajo; el resto ya está rellenado.' : 'Foto leída. Comprueba los datos de abajo y pulsa «Ver motores para estos datos».';
      showReview();
    } catch (error) {
      if (current === revision) {
        status.textContent = error.name === 'AbortError' ? 'La lectura no ha terminado. Puedes volver a probar o escribir los datos abajo.' : error.message;
        showReview();
      }
    } finally {
      clearTimeout(timer);
      busy = false;
      button.disabled = !validEndpoint;
    }
  });
})();
